export default __webpack_public_path__ + "static/media/GuidelinesFR.22481eca.pdf";